type SectionHeadProps = {
  kicker?: string;
  title: string;
  desc?: string;
  tone?: "default" | "light" | "ink";
  align?: "left" | "center";
};

export default function SectionHead({ kicker, title, desc, tone = "default", align = "left" }: SectionHeadProps) {
  const onDark = tone === "light";
  const center = align === "center";
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      {kicker && (
        <div className={`inline-flex items-center gap-2 ${center ? "justify-center" : ""} mb-3`}>
          <span className="h-1.5 w-6 rounded-full bg-accent-500" aria-hidden="true" />
          <span className="text-xs font-bold tracking-[0.2em] text-accent-700 uppercase">
            {kicker}
          </span>
        </div>
      )}
      <h2
        className={`text-2xl md:text-4xl font-black leading-tight tracking-tight ${
          tone === "ink" ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 text-sm md:text-base ${onDark ? "text-background-200" : "text-foreground-700"}`}>
          {desc}
        </p>
      )}
    </div>
  );
}